<template>
    <div>
        <!-- @todo: when Centuria solved problem with server next line will be must uncomment -->
        <!-- <VitePwaManifest /> -->
        <NuxtPage />
    </div>
</template>
